import React, { Component } from "react";
import _ from "lodash";
import classnames from "classnames";
import { Dropdown, Form, Message } from "semantic-ui-react";

import { countries } from "../common";
import { translate } from "../../addons/Translate";

class VerifyPhoneForm extends Component {
    state = {
        data: {
            country: window.restaurant.phone_country,
            country_text: window.restaurant.phone_country_code,
            phone: "",
        },
        loading: false,
        error_server: false,
        errors_response: {},
        errors: {},
    };

    componentWillReceiveProps(props) {
        if (!!props.data && !_.isEqual(props.data, this.props.data)) {
            this.setState({
                data: {
                    name: !!props.data.name ? props.data.name : "",
                },
                errors: {},
            });
        }
    }

    onChangeCheckErrors(name) {
        if (this.state.errors[name] !== undefined) {
            this.setState({
                errors: _.omit(this.state.errors, name),
            });
        }
    }

    onChange(e) {
        this.setState({
            ...this.state,
            data: { ...this.state.data, [e.target.name]: e.target.value },
        });

        this.onChangeCheckErrors(e.target.name);
    }

    onChangeNumber = (e) => {
        const re = /^[0-9\s]+$/;
        const value = e.target.value;

        if (value === "" || re.test(value)) {
            this.setState({
                data: {
                    ...this.state.data,
                    [e.target.name]: value,
                },
            });

            this.onChangeCheckErrors(e.target.name);
        }
    };

    onChangeCountry(e, { value }) {
        let cc = 0;
        for (var i in countries) {
            if (countries[i].value === value) {
                cc = "+" + countries[i].callingcode;
                break;
            }
        }

        this.setState({
            data: {
                ...this.state.data,
                country: value,
                country_text: cc,
            },
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const errors = this.validate(this.state.data);

        this.setState({ errors });

        if (Object.keys(errors).length === 0) {
            this.setState({ loading: true });
            this.props.onSubmit(this.state.data);
            // .then(res => {
            // 	if(res.status === "error") {
            // 		this.setState({
            // 			errors_response: res.errors,
            // 			loading: false
            // 		})
            // 	}
            // })
            // .catch((err) => {
            // 	if(err !== undefined) {
            // 		this.setState({
            // 			loading: false,
            // 			errors_response: {
            // 				phone: err
            // 			}
            // 		});
            // 	} else {
            // 		this.setState({
            // 			loading: false,
            // 			error_server: true
            // 		});
            // 	}
            // });
        }
    };

    validate(data) {
        const errors = {};

        if (!data.phone) errors.phone = true;

        return errors;
    }

    renderErrorMessage() {
        const { errors_response, error_server } = this.state;

        if (error_server) {
            return (
                <Message negative>
                    <p>{translate("xxltable.errors.server")}</p>
                </Message>
            );
        }

        if (Object.keys(errors_response).length > 0) {
            return (
                <Message negative>
                    {Object.keys(errors_response).map((error) => (
                        <div key={error}>{errors_response[error]}</div>
                    ))}
                </Message>
            );
        }

        return null;
    }

    render() {
        const { data, errors, loading } = this.state;

        return (
            <Form onSubmit={this.onSubmit.bind(this)} loading={loading}>
                <Message color="yellow">
                    {translate("xxltable.step1.info")}
                </Message>

                {this.renderErrorMessage()}

                <Form.Group widths="equal">
                    <Dropdown
                        button
                        className="country_code"
                        floating
                        labeled
                        options={countries}
                        search
                        text={
                            <span>
                                <i
                                    className={classnames("flag", data.country)}
                                />
                                {data.country_text}
                            </span>
                        }
                        value={data.country}
                        onChange={this.onChangeCountry.bind(this)}
                    />

                    <Form.Input
                        autoFocus
                        placeholder={translate("xxltable.step1.phone")}
                        icon="phone"
                        iconPosition="left"
                        name="phone"
                        value={data.phone}
                        onChange={this.onChangeNumber.bind(this)}
                        error={!!errors.phone}
                    />
                </Form.Group>

                <div className="ui center aligned container">
                    <Form.Button positive>
                        {translate("xxltable.step1.btn_next")}
                    </Form.Button>
                </div>
            </Form>
        );
    }
}

export default VerifyPhoneForm;



// WEBPACK FOOTER //
// ./src/components/forms/VerifyPhoneForm.js